import { initExternalGlobalPromise, initGlobal } from '@meego/remote-loader';
import { init as initCommonExternals } from 'src/remote/external-config/common';
import { init as initExternalConfig } from 'src/remote/external-config';

export const init = () => {
  // 初始化 remote-loader 到全局，给分仓库使用，不能放到 bootstrap 的原因是，bootstrap 的依赖太多，已经依赖了业务
  initGlobal();

  // 初始化主仓库中的 external config，防止后续模块早于 enterApp 执行前访问 @meego-progressive/xxx 的时候无法访问到
  initCommonExternals();
  // 初始化 __MEEGO_EXTERNALS_PROMISE__，让 bootstrap 中静态引用到的 meego-progressive 主仓模块可正常工作
  initExternalGlobalPromise();

  // from stepInitRemoteLoader
  initExternalConfig();
};
